import { render, staticRenderFns } from "./DownloadDocument.vue?vue&type=template&id=09ac9d3e&scoped=true"
import script from "./DownloadDocument.vue?vue&type=script&lang=ts"
export * from "./DownloadDocument.vue?vue&type=script&lang=ts"
import style0 from "./DownloadDocument.vue?vue&type=style&index=0&id=09ac9d3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ac9d3e",
  null
  
)

export default component.exports